import { useTranslation } from 'react-i18next';
import { Icon, Page } from '@/components';
import { ArticlesOverviewPanel, ArticlesSearchBar } from '@/views';
import { useState } from 'react';

export function ArticleOverviewPage() {
  const { t } = useTranslation();
  const [searchString, setSearchString] = useState<string>();

  return (
    <Page htmlTitle={t('articles.overview.title')}>
      <Page.Paths>
        <Page.Path>{t('articles.overview.title')}</Page.Path>
      </Page.Paths>

      <Page.Body>
        <Page.Card
          title={t('articles.overview.title')}
          icon={<Icon type="article" />}
          color="#814A93"
          actions={<ArticlesSearchBar onSearch={setSearchString} />}
        >
          <ArticlesOverviewPanel searchString={searchString} />
        </Page.Card>
      </Page.Body>
    </Page>
  );
}
